import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import { stepTitle, t } from '../common/text';
/** The member's journey as their own user carries it (no live counts). */
export function own() {
  return app.session.user?.attribute('onramp') ?? null;
}

/** An open journey whose launcher the admin left on. */
export function showsLauncher() {
  const journey = own();
  return !!journey && journey.status === 'open' && journey.launcher;
}
export function setOwn(journey) {
  app.session.user?.pushAttributes({
    onramp: journey
  });
}

/** The full read — live counts — kept for a short while between opens. */
let full = null;
let inflight = null;
export function fullJourney() {
  return full?.data ?? null;
}
export function loadFull(force) {
  if (force === void 0) {
    force = false;
  }
  if (!force && full && Date.now() - full.at < 30_000) return Promise.resolve(full.data);
  if (inflight) return inflight;
  inflight = app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/onramp'
  }).then(res => {
    remember(res.data);
    celebrate(res.meta, res.data);
    return res.data;
  }).finally(() => {
    inflight = null;
  });
  return inflight;
}
export function act(action, body) {
  if (body === void 0) {
    body = {};
  }
  return app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/onramp/' + action,
    body
  }).then(res => {
    remember(res.data);
    celebrate(res.meta, res.data);
    m.redraw();
    return res.data;
  });
}

/** Keep the full read and the session user's copy in step. */
export function remember(journey) {
  full = {
    at: Date.now(),
    data: journey
  };
  setOwn(journey);
}

/** Drop the full read, so the next open refetches live counts. */
export function stale() {
  full = null;
}

/** Last step the member was told about, so a repeated meta never toasts twice. */
const told = new Set();
let toldGraduation = false;

/**
 * Toasts for what the member just did. The server sends the news in the
 * response to the very request that completed the step, so the toast lands
 * on whatever page the member is on.
 */
export function celebrate(meta, journey) {
  if (!meta) return;
  const steps = journey?.steps || own()?.steps || [];
  meta.completed.filter(id => !told.has(id)).forEach(id => {
    told.add(id);
    const step = steps.find(s => s.id === id);
    if (!step) return;
    const reward = [step.points ? extractText(t('forum.toast.points', {
      count: step.points
    })) : '', step.badge ? step.badge.name : ''].filter(Boolean).join(' · ');
    app.alerts.show({
      type: 'success',
      icon: 'fas fa-circle-check',
      className: 'OnrampToast'
    }, extractText(t('forum.toast.step', {
      title: extractText(stepTitle(step))
    })) + (reward ? ` — ${reward}` : ''));
  });
  if (meta.graduated && !toldGraduation) {
    toldGraduation = true;
    app.alerts.show({
      type: 'success',
      icon: 'fas fa-flag-checkered',
      className: 'OnrampToast OnrampToast--graduated'
    }, t('forum.toast.graduated'));
  }
}